// Where a watched tournament stands, for the badge above the spectator tabs.
//
// The badge used to say "Live" whatever happened, so a tournament that ended last
// spring — every round played, the final standings up — still told its readers it was
// live. The phase comes from the tournament itself first (rounds and results), and
// only then from its dates, because dates are what an organiser types once and never
// corrects: a tournament whose last round is complete is finished whatever its end date
// says, and one still being played on the day after its end date is still live.

/**
 * @param {object} o
 * @param {object[]} o.rounds        the rounds generated so far (the group on screen)
 * @param {number}   o.roundsCount   how many rounds the tournament is set to have
 * @param {string}   [o.startDate]   'YYYY-MM-DD'
 * @param {string}   [o.endDate]     'YYYY-MM-DD'
 * @param {string}   o.today         'YYYY-MM-DD' (Norway's date: js/utils/oslo-date.js)
 * @returns {'upcoming'|'live'|'finished'}
 */
export function spectatorPhase({ rounds, roundsCount, startDate, endDate, today }) {
    const list = Array.isArray(rounds) ? rounds : [];
    const total = parseInt(roundsCount, 10) || 0;

    if (list.length > 0) {
        const last = list[list.length - 1];
        const lastComplete = (last.pairings || []).every(p => !!p.result);
        if (total > 0 && list.length >= total && lastComplete) return 'finished';
        // Rounds exist but the last is still being played, or more are to come: live,
        // unless the event's last day is long gone and nobody finished entering it.
        if (endDate && endDate < today && lastComplete) return 'finished';
        return 'live';
    }
    if (startDate && startDate > today) return 'upcoming';
    if (endDate && endDate < today) return 'finished';
    return 'live';
}
